<template>
  <div class="artist-lists">
    <v-artist-list
      v-for="(data, level) in sortedData"
      :id="`list-${level}`"
      :key="level"
      :level="level"
      :data="data"
      :artist-id="artistId"
      @mouseoverartist="$emit('mouseoverartist', $event)"
      @mouseoverrole="$emit('mouseoverrole', $event)"
    />
  </div>
</template>

<script>

import ArtistList from "./ArtistList";

export default {
	components: {
		"v-artist-list": ArtistList
	},
	props: {
		artistId: {
			type: String,
			required: true
		},
		artists: {
			type: Array,
			required: true
		}
	},
	computed: {
		sortedData () {
			let data = {};
			let levels = ["source", "own", "target"];
			levels.forEach(level => {
				data[level] = this.artists
					.filter(a => a[level].total > 0)
					.sort((a,b) => (a[level].total > b[level].total) ? -1 : 1)
					.map(a => {
						a.artist = this.$store.state.artists[a.id];
						return a;
					});
			});
			return data;
		}
	}
};
</script>

<style lang="scss" scoped>
.artist-lists {
    display: flex;
    border-top: 1px #f1f1f1 solid;
    border-bottom: 1px #f1f1f1 solid;
    border-left: 1px #f1f1f1 solid;
}
</style>
